const patientData = {
  PATIENT_ID: "Unique identifier for each patient",
  ENCOUNTER_ID: "Unique identifier for each patient visit or encounter",
  AGE: "Age of the patient at the time of the encounter",
  SEX: "Biological sex of the patient",
  SURGERY_ID: "Unique identifier for the surgery performed",
  SX_EYE_DX: "Diagnosis for the surgery eye",
  FELLOW_EYE_DX: "Diagnosis for the fellow (non-surgery) eye",
  SX_EYE: "Eye on which surgery was performed",
  SYSTEMIC_HISTORY: "Record of systemic medical conditions",
  REMARKS_GENERAL: "General remarks or observations",
  OTHER_SYSTEMIC_HISTORY: "Additional details about systemic medical history",
  MEDIA_RE: "Description of the ocular media for the right eye",
  MEDIA_LE: "Description of the ocular media for the left eye",
  DISC_RE: "Observations related to the optic disc in the right eye",
  DISC_LE: "Observations related to the optic disc in the left eye",
  VESSELS_RE: "Description of the retinal vessels in the right eye",
  VESSELS_LE: "Description of the retinal vessels in the left eye",
  BG_RETINA_RE: "Background retina observations for the right eye",
  BG_RETINA_LE: "Background retina observations for the left eye",
  MACULA_RE: "Macula observations for the right eye",
  POST_SEG_REMARKS_RE: "Posterior segment remarks for the right eye",
  POST_SEG_REMARKS_LE: "Posterior segment remarks for the left eye",
  LID_RE: "Eyelid observations for the right eye",
  LID_LE: "Eyelid observations for the left eye",
  CONJUNCTIVA_RE: "Conjunctiva observations for the right eye",
  CONJUNCTIVA_LE: "Conjunctiva observations for the left eye",
  CORNEA_RE: "Cornea observations for the right eye",
  CORNEA_LE: "Cornea observations for the left eye",
  AC_RE: "Anterior chamber observations for the right eye",
  AC_LE: "Anterior chamber observations for the left eye",
  IRIS_RE: "Iris observations for the right eye",
  IRIS_LE: "Iris observations for the left eye",
  PUPIL_RE: "Pupil observations for the right eye",
  PUPIL_LE: "Pupil observations for the left eye",
  LENS_RE: "Lens observations for the right eye",
  OM_RE: "Ocular movement observations for the right eye",
  OM_LE: "Ocular movement observations for the left eye",
  CORNEA_REFLEX_RE: "Corneal reflex observations for the right eye",
  CORNEA_REFLEX_LE: "Corneal reflex observations for the left eye",
  GLOBE_RE: "Globe observations for the right eye",
  GLOBE_LE: "Globe observations for the left eye",
  UNDIL_FUNDUS_RE: "Undilated fundus observations for the right eye",
  UNDIL_FUNDUS_LE: "Undilated fundus observations for the left eye",
  ANT_SEG_REMARKS_RE: "Anterior segment remarks for the right eye",
  ANT_SEG_REMARKS_LE: "Anterior segment remarks for the left eye",
  SX_UCVA: "Unaided visual acuity for the surgery eye",
  FF_UCVA: "Unaided visual acuity for the fellow (non-surgery) eye",
  SX_BCVA: "Best corrected visual acuity for the surgery eye",
  FF_BCVA: "Best corrected visual acuity for the fellow eye",
  SX_PHVA: "Pinhole visual acuity for the surgery eye",
  FF_PHVA: "Pinhole visual acuity for the fellow eye",
  NVI_SX: "Presence of neovascularization of the iris in the surgery eye",
  NVI_FELLOW: "Presence of neovascularization of the iris in the fellow eye",
  SX_UCVA_LM: "LogMAR conversion of unaided visual acuity for the surgery eye",
  FF_UCVA_LM: "LogMAR conversion of unaided visual acuity for the fellow eye",
  SX_BCVA_LM:
    "LogMAR conversion of best corrected visual acuity for the surgery eye",
  FF_BCVA_LM:
    "LogMAR conversion of best corrected visual acuity for the fellow eye",
  SX_PHVA_LM: "LogMAR conversion of pinhole visual acuity for the surgery eye",
  FF_PHVA_LM: "LogMAR conversion of pinhole visual acuity for the fellow eye",
  SX_FINAL_UCVA: "Final unaided visual acuity for the surgery eye",
  SX_FINAL_UCVA_LM:
    "LogMAR conversion of final unaided visual acuity for the surgery eye",
  SX_FINAL_BCVA: "Final best corrected visual acuity for the surgery eye",
  SX_FINAL_BCVA_LM:
    "LogMAR conversion of final best corrected visual acuity for the surgery eye",
  SX_EYE_OBS: "Observations and findings related to the surgery eye",
  FELLOW_EYE_OBS: "Observations and findings related to the fellow eye",
  SX_EYE_REMARKS: "Remarks specific to the surgery eye",
  FELLOW_EYE_REMARKS: "Remarks specific to the fellow eye",
};

export default patientData;
